export default "<p>info-business works!</p>\r\n"